<ion-tabs> <!-- Navegasion -->
    <ion-tab-bar slot="bottom">
        <ion-tab-button tab="schedule">
            <ng-container *ngIf="currentUrl !== '/schedule'">
                <img src="assets/icons/calendar.svg" alt="edit" class="am-icon" />
            </ng-container>
            <ng-container *ngIf="currentUrl === '/schedule'">
                <img src="assets/icons/calendar-selected.svg" alt="edit" class="am-icon" />
            </ng-container>
            {{ 'feature_schedule' | translate }}
        </ion-tab-button>

        <ion-tab-button tab="workout">
            <ng-container *ngIf="currentUrl !== '/workout'">
                <img src="assets/icons/user-contact-selected.svg" alt="edit" class="am-icon" />
            </ng-container>
            <ng-container *ngIf="currentUrl === '/workout'">
                <img src="assets/icons/user-contact-selected.svg" alt="edit" class="am-icon" />
            </ng-container>
            {{ 'assign_workout' | translate }}
        </ion-tab-button>
    </ion-tab-bar>
</ion-tabs>